import React, { useState } from "react";
import { Button } from "../../components/ui";
import { FcGoogle } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
import { RxReload } from "react-icons/rx";
import toast from "react-hot-toast";
import useAuth from "../../hooks/useAuth";
import { GoogleLogin } from '@react-oauth/google';
import Cookies from 'universal-cookie';
import { COMPANY_ID, COMPANYNAME, NAME, ROLE, TOKEN_NAME, COMPANY_EMPLOYEE_ID, IS_LIVE_TRACKING, IS_CHAT, IS_HRMS } from "../../config";


const cookies = new Cookies
const LoginWithGoogle = () => {
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const loginGoogle = useAuth({
        url: "/googleLogin",
        onSuccess: (res) => {
            /**
             * email: "mukeshswamy9945@gmail.com"
             * message: "Login Success"
             * name: "sanjay bhandari"
             * profile_image: ""
             * role: "employee"
             * token: "eyJ0e"
             */
            const { token, role, company_id, company_name, name, company_employee_id, access_type } = res?.data?.data
           
            cookies.set(TOKEN_NAME, token, { path: '/' })
            cookies.set(ROLE, role, { path: '/' })
            cookies.set(NAME, name, { path: "/" });
            cookies.set(COMPANY_ID, company_id, { path: '/' })
            cookies.set(COMPANYNAME, company_name, { path: '/' })
            cookies.set(COMPANY_EMPLOYEE_ID, company_employee_id, { path: "/" });
            
            // Set access type cookies
            if (access_type) {
                cookies.set(IS_LIVE_TRACKING, access_type?.is_live_tracking, { path: "/" });
                cookies.set(IS_CHAT, access_type?.is_chat, { path: "/" });
                cookies.set(IS_HRMS, access_type?.is_hrms, { path: "/" });
            }
            
            setIsLoading(false);
            navigate("/", { replace: true });
        },
        onError: ({ status, data }) => {
            if (status === 500) {
                toast.error("Internal server error");
            } else if (status >= 400 || status <= 499) {
                toast.error(data.message);
            }
            setIsLoading(false);

        },
    });
    const googleLoginSuccess = (tokenResponse) => {
        const { credential } = tokenResponse;
        loginGoogle.mutate({ code: credential });
    };

    const googleLoginError = (error) => {
        toast.error(error);
    };

    return (
        <>
            <div className="pb-5">
                <Button
                    disabled={isLoading}
                    variant="outline"
                    className=" w-[300px] py-5 h-0 absolute pointer-events-none z-20 bg-white"
                >
                    <FcGoogle className="mr-2 h-4 w-4" />
                    Login with Google
                    {isLoading && <RxReload className="ml-2 h-4 w-4 animate-spin" />}
                </Button>

                <GoogleLogin
                    width={300}
                    onSuccess={credentialResponse => {
                        googleLoginSuccess(credentialResponse);
                    }}
                    onError={() => {
                        googleLoginError('Login Failed');
                    }}
                    logo_alignment={"center"}
                />
            </div>
        </>
    );
};

export default LoginWithGoogle;
